import React from "react";
import Services from "./OffersCards";
import "../../styles/ServicesSection/ServicesSection.scss";
import { useTranslation } from "react-i18next";
import { OffersHeader } from "./OffersHeader";

export const OffersSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="servicesSection" id="servicesSection">
      <p>{t("what_we_do")}</p>
      <OffersHeader />
      <Services />
    </section>
  );
};
